var map = {
	"./Hi.json": 90500,
	"./br.json": 47309,
	"./en.json": 20790,
	"./es.json": 18563,
	"./in-IN.json": 96247,
	"./ja.json": 8566,
	"./ko.json": 37697,
	"./pt.json": 69898,
	"./th.json": 42009,
	"./zh-CN.json": 89890,
	"./zh-TW.json": 46687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6977;